import DocumentModelBase from '../_generated/modelBases/document-model-base';

export default class DocumentModel extends DocumentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
